import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CUSTOM_MASKS } from '@app/shared/services';
import { BaseService } from '@app/shared/services/base';
import { TrabalheConoscoService } from './trabalhe-conosco.service';

@Component({
  selector: 'app-trabalhe-conosco',
  templateUrl: './trabalhe-conosco.component.html',
  styleUrls: ['./trabalhe-conosco.component.scss'],
})
export class TrabalheConoscoComponent implements OnInit {
  public formCandidato: UntypedFormGroup = new UntypedFormGroup({
    nome: new UntypedFormControl(null, [Validators.required]),
    email: new UntypedFormControl(null, [Validators.required]),
    contato: new UntypedFormControl(null, [Validators.required]),
    apresentacao: new UntypedFormControl(null, [Validators.required]),
    linkCurriculo: new UntypedFormControl(null, [Validators.required]),
  });

  public masks = CUSTOM_MASKS.masks;
  public curriculoId: string;
  public event: any;
  public showForm: boolean = true;


  constructor(private _trabalheConoscoService: TrabalheConoscoService, private _base: BaseService) {}

  ngOnInit(): void {
    this._setTitle();
  }

  private _setTitle(): void {
    this._base._titleService.setTitle('Trabalhe conosco');
  }

  public async salvar() {
    this._base._loading.start();
    await this.uploadCurriculo();

    this._trabalheConoscoService
      .saveCurriculo(this.formCandidato.getRawValue())
      .subscribe(
        () => {
          this._base._toast.success('Seu currículo foi enviado com sucesso!');
          this.showForm = false;
        },
        (err) => {
          console.error(err);
          this._base._toast.error('Algo deu errado');
        }
      )
      .add(() => {
        this._base._loading.stop();
      });
  }

  public scrollTo(element: any): void {
    (document.getElementById(element) as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }

  public get controls() {
    return this.formCandidato.controls;
  }

  public setEvent(event: any) {
    this.event = event.target.files[0];
    this.controls.linkCurriculo.patchValue(this.event.name);
  }

  public async uploadCurriculo() {
    await this._trabalheConoscoService
      .uploadFile(this.event, this.controls.contato.value)
      .then((res) => {
        this.controls.linkCurriculo.patchValue(res);
      })
      .catch((err) => {
        this._base._alert.error('Algo deu errado', err.message);
        console.error(err);
      })
      .finally(() => {
        this._base._loading.stop();
      });
  }
}
